import { contractorConstants } from "../../constants";

const defaultState = {
    items: [],
    item: {},
    loadingItems: false,
    loadingItem: false,
    fetchedItems: false,
    fetchedItem: false,
    deleted: false,
    error: null
};

function normalData(arr) {
    if (!Array.isArray(arr)) return []

    return arr.map((elem, index) => Object.assign(elem, { index: (index + 1) }))
}

export const groupReducer = function (state = defaultState, action) {
    switch (action.type) {
        case contractorConstants.GETALL_REQUEST_GROUPS:
            return {
                ...state,
                item: {},
                loadingItems: true,
                loadingItem: false,
                fetchedItems: false,
                fetchedItem: false,
                error: null,
                deleted: false,
            };
        case contractorConstants.GETALL_SUCCESS_GROUPS:
            return {
                ...state,
                items: normalData(action.response),
                loadingItems: false,
                fetchedItems: true,
            };
        case contractorConstants.GETALL_FAILURE_GROUPS:
            return {
                ...state,
                loadingItems: false,
                fetchedItems: false,
                error: action.error,
            };

        case contractorConstants.GETBYID_REQUEST_GROUPS:
            return {
                ...state,
                item: {},
                loadingItem: true,
                fetchedItem: false,
                error: null,
                deleted: false,
            };
        case contractorConstants.GETBYID_SUCCESS_GROUPS:
            return {
                ...state,
                item: action.response,
                loadingItem: false,
                fetchedItem: true,
            };
        case contractorConstants.GETBYID_FAILURE_GROUPS:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                error: action.error,
            };

        case contractorConstants.CREATE_REQUEST_GROUPS:
            return {
                ...state,
                item: {},
                loadingItem: true,
                fetchedItem: false,
                error: null
            };
        case contractorConstants.CREATE_SUCCESS_GROUPS:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: true,
                item: action.response,
                items: normalData(state.items.concat(action.response))
            };
        case contractorConstants.CREATE_FAILURE_GROUPS:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                error: action.error,
            };

        case contractorConstants.UPDATE_REQUEST_GROUPS:
            return {
                ...state,
                loadingItem: true,
                fetchedItem: false,
                error: null
            };
        case contractorConstants.UPDATE_SUCCESS_GROUPS:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: true,
                item: action.response,
                items: normalData(state.items.map((elem) => {
                    if (elem.id === action.response.id) return Object.assign(elem, { ...action.response })
                    return elem
                }))
            };
        case contractorConstants.UPDATE_FAILURE_GROUPS:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                error: action.error,
            };

        case contractorConstants.ARCHIVE_REQUEST_GROUPS:
            return {
                ...state,
                loadingItem: true,
                fetchedItem: false,
                error: null,
            };
        case contractorConstants.ARCHIVE_SUCCESS_GROUPS:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                items: normalData(state.items.map((elem) => {
                    if (elem.id === action.id) return Object.assign(elem, { ...action.response, isArchive: !elem.isArchive })
                    return elem
                }))
            };
        case contractorConstants.ARCHIVE_FAILURE_GROUPS:
            return {
                ...state,
                loadingItem: false,
                error: action.error,
            };

        case contractorConstants.DELETE_REQUEST_GROUPS:
            return {
                ...state,
                item: {},
                loadingItems: true,
                loadingItem: false,
                fetchedItems: false,
                fetchedItem: false,
                deleted: false,
                error: null
            };
        case contractorConstants.DELETE_SUCCESS_GROUPS:
            return {
                ...state,
                loadingItems: false,
                fetchedItems: true,
                items: normalData(state.items.filter((elem) => elem.id !== action.id)),
                deleted: true,
            };
        case contractorConstants.DELETE_FAILURE_GROUPS:
            return {
                ...state,
                loadingItems: false,
                fetchedItems: false,
                error: action.error,
                deleted: false,
            };

        case "RESET_ITEM_GROUPS":
            return {
                ...state,
                fetchedItem: false,
                loadingItem: false,
                deleted: false,
                item: {}
            }

        case "RESET_ITEMS_GROUPS":
            return {
                ...state,
                fetchedItems: false,
                loadingItems: false,
                deleted: false,
                items: [],
                error: null
            }
        default:
            return state;
    }
}